export const clearLabelSessionStorage = (hash: string): void => {
  sessionStorage.removeItem(`label_confidence_${hash}`)
  sessionStorage.removeItem(`label_ocr_${hash}`)
  sessionStorage.removeItem(`label_image_${hash}`)
}
